export default __webpack_public_path__ + "static/media/login-icon5.d869025b.png";